import React, { Component } from 'react'
import Card from '../card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import CardTitle from '../../card-title/card-title'
import { getCall, baseUrl } from '../../../../../helpers/api'

class TypeCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            types: []
        }
    }

    async componentDidMount() {
        const types = await getCall("/treeCali/getall")
        await this.setState({ types: types.data })
    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Ağaç veya Çalı" />
                <CardHolder>
                    {this.state.types.map((t, index) => (
                        <Card key={index} history={this.props.history} image={baseUrl + t.image} typeText={t.typeName} />
                    ))}
                </CardHolder>
            </CardContainer>
        )
    }
}

export default TypeCardsExample
